let d = window.define;
import "ember-compatibility-helpers/-embroider-implicit-modules.js";